import {
  getElementControls,
  getElementTypeFilterOptions,
} from "core-integration/src/store/elements/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { getTeams } from "core-integration/src/store/teams/reducers";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FieldWrap, SelectField } from "../FieldRenderers";

type Props = {
  handleFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const ElementFilter: React.FC<Props> = ({ handleFilterChange }) => {
  const controls = useSelector(getElementControls);
  const elementTypeFilterOptions = useSelector(getElementTypeFilterOptions);
  const player = useSelector(getPlayerData);
  const { t } = useTranslation();
  const teams = useSelector(getTeams);

  // filterTeams
  const filterTeams = teams
    .filter((team: any) => team.unavailable === false)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <FieldWrap>
      <SelectField
        id="filter"
        name="filter"
        label={t("elementFilter.view", "View")}
        value={controls.filter}
        onChange={handleFilterChange}
        required={false}
      >
        <optgroup label={t<string>("elementFilter.global", "Global")}>
          <option value="all" aria-selected={controls.filter === "all"}>
            {t("elementFilter.allPlayers", "All players")}
          </option>
          {player && player.entry && (
            <option value="wl" aria-selected={controls.filter === "wl"}>
              {t("elementFilter.watchList", "Watchlist")}
            </option>
          )}
        </optgroup>
        <optgroup label={t<string>("elementFilter.byPosition", "By position")}>
          {elementTypeFilterOptions.map((o) => (
            <option
              key={o.value}
              value={o.value}
              aria-selected={controls.filter === o.value}
            >
              {o.label}
            </option>
          ))}
        </optgroup>
        <optgroup label={t<string>("elementFilter.topLeague", "By team")}>
          {filterTeams.map((o) => (
            <option
              key={`te_${o.id}`}
              value={`te_${o.id}`}
              aria-selected={controls.filter === `te_${o.id}`}
            >
              {o.name}
            </option>
          ))}
        </optgroup>
      </SelectField>
    </FieldWrap>
  );
};

export default ElementFilter;
